var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 35C60 37.75 57.75 40 55 40H5C2.25 40 0 37.75 0 35V5C0 2.25 2.25 0 5 0H55C57.75 0 60 2.25 60 5V35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 29.206C50 32.6289 47.2127 35.4162 43.7897 35.4162H10V10.8196C10 7.39666 12.7873 4.60938 16.2103 4.60938H50V29.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2714 6.6875C38.8265 6.6875 36.8216 8.66794 36.8216 11.1374V15.7584H43.1052C43.2519 15.7584 43.423 15.7584 43.5453 15.7829C44.9634 15.8562 46.0147 16.5897 46.0147 17.8611C46.0147 18.8635 45.3057 19.7193 43.9854 19.8904V19.9393C45.4279 20.0371 46.5282 20.844 46.5282 22.0909C46.5282 23.4357 45.3057 24.3159 43.692 24.3159H36.7971V33.3623H43.3252C45.7702 33.3623 47.7751 31.3819 47.7751 28.9124V6.6875H41.2714Z",
    fill: "url(#paint0_linear_202_313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9976 22.8977H41.5648C41.6015 22.8977 41.6626 22.8916 41.7238 22.8855C41.7849 22.8794 41.846 22.8733 41.8827 22.8733C42.3717 22.7755 42.7873 22.3354 42.7873 21.7242C42.7873 21.1374 42.3717 20.6973 41.8827 20.575C41.8093 20.5506 41.6626 20.5506 41.5648 20.5506H38.9976V22.8977Z",
    fill: "url(#paint1_linear_202_313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5648 17.1031C42.0538 17.1765 42.4695 17.5677 42.4695 18.1545C42.4695 18.7413 42.0538 19.1325 41.5648 19.2058C41.5404 19.2303 41.3937 19.2303 41.3203 19.2303H38.9976V17.0787H41.3203C41.3607 17.0787 41.4159 17.0861 41.4655 17.0928C41.5061 17.0982 41.5429 17.1031 41.5648 17.1031Z",
    fill: "url(#paint2_linear_202_313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6748 6.6875C14.2298 6.6875 12.2249 8.66794 12.2249 11.1374V22.1154C13.4718 22.7266 14.7677 23.1178 16.0635 23.1178C17.6039 23.1178 18.4352 22.1887 18.4352 20.9173V15.734H22.2493V20.8929C22.2493 22.8978 21.0024 24.5359 16.7726 24.5359C14.2053 24.5359 12.2004 23.9736 12.2004 23.9736V33.3379H18.7286C21.1735 33.3379 23.1784 31.3574 23.1784 28.888V6.6875H16.6748Z",
    fill: "url(#paint3_linear_202_313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9731 6.6875C26.5281 6.6875 24.5232 8.66794 24.5232 11.1374V16.9564C25.6479 16.0029 27.6039 15.3917 30.7579 15.5384C32.445 15.6117 34.2542 16.0763 34.2542 16.0763V17.9589C33.3496 17.4943 32.2738 17.0787 30.8802 16.9809C28.4841 16.8097 27.0415 17.9833 27.0415 20.0371C27.0415 22.1154 28.4841 23.289 30.8802 23.0934C32.2738 22.9956 33.3496 22.5555 34.2542 22.1154V23.998C34.2542 23.998 32.4694 24.4626 30.7579 24.5359C27.6039 24.6826 25.6479 24.0714 24.5232 23.1178V33.3868H31.0513C33.4963 33.3868 35.5012 31.4063 35.5012 28.9369V6.6875H28.9731Z",
    fill: "url(#paint4_linear_202_313)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_313",
    x1: 36.8167,
    y1: 18.1508,
    x2: 47.8043,
    y2: 18.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_313",
    x1: 36.8167,
    y1: 18.1508,
    x2: 47.8043,
    y2: 18.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_202_313",
    x1: 36.8167,
    y1: 18.1508,
    x2: 47.8043,
    y2: 18.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_202_313",
    x1: 12.2193,
    y1: 20.0138,
    x2: 23.3768,
    y2: 20.0138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_202_313",
    x1: 24.4596,
    y1: 20.0138,
    x2: 35.2958,
    y2: 20.0138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoJcb);
export default __webpack_public_path__ + "static/media/ico_jcb.651d37a91ade8750e95a0d81c3daef86.svg";
export { ForwardRef as ReactComponent };